/** Shared metrics for small status pills (benchmark chips, retention status). */
export const PILL_BADGE_STYLES = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 9999,
  padding: '2px 8px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  whiteSpace: 'nowrap',
}
